import PageServicesFactory from '../../page/Services/factory.js'
import {SearchMappersFactory} from '../Mappers/factory.js'
import {SearchRepositoriesFactory} from '../Repositories/factory.js'
import {SearchValueObjectsFactory} from '../ValueObjects/factory.js'
import {GetNavigationLinksSearchService} from './GetNavigationLinksSearchService.js'
import {GetRequestSearchService} from './GetRequestSearchService.js'
import GetUrlSearchService from './GetUrlSearchService.js'
import {SaveNavigationDataSearchService} from './SaveNavigationDataSearchService.js'

export class SearchServicesFactory {
  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetUrlSearchService}
   */
  static getUrlSearchService = ({config}) =>
    new GetUrlSearchService({
      config,
      searchRequestValueObject: SearchValueObjectsFactory.searchRequestValueObject,
      fromSearchJSONToUrlVOProxyMapper: SearchMappersFactory.fromSearchJSONToUrlVOProxyMapper({config}),
      getUrlService: PageServicesFactory.getUrlService({config})
    })

  static getRequestSearchService = ({config}) =>
    new GetRequestSearchService({
      config,
      fromSearchParamsToRequestVOMapper: SearchMappersFactory.fromSearchParamsToRequestVOMapper({config})
    })

  static saveNavigationDataSearchService = ({config}) =>
    new SaveNavigationDataSearchService({
      config,
      localStorageRepository: SearchRepositoriesFactory.localStorageSearchRepository({config})
    })

  static getNavigationLinksSearchService = ({config}) =>
    new GetNavigationLinksSearchService({
      config,
      localStorageRepository: SearchRepositoriesFactory.localStorageSearchRepository({config})
    })
}
